/**
 * External dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

export const device = (
	<SVG width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M14.0039 47.9999H42.026V44.0449H14.0039V47.9999Z"
			fill="var(--wpds-color-background-track-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M43.5519 12.125H12.4763C10.0188 12.125 8.02832 14.1136 8.02832 16.5688V34.073H47.9998V16.5688C47.9998 14.1136 46.0094 12.125 43.5519 12.125Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M42.026 36.1348H14.0039V40.0898H42.026V36.1348Z"
			fill="var(--wpds-color-stroke-surface-brand, #D1C1FF)"
		/>
		<Path
			d="M8.02832 34.0728V35.6459C8.02832 38.1011 10.0188 40.0897 12.4763 40.0897H43.5519C46.0094 40.0897 47.9998 38.1011 47.9998 35.6459V34.0728H8.02832Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Path
			d="M35.304 40.0898H21.293V44.0448H35.304V40.0898Z"
			fill="var(--wpds-color-background-track-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M12.1807 0H3.87639C1.40111 0 0 1.37981 0 3.8439V25.9008C0 28.3627 1.40333 29.7447 3.87862 29.7447H12.1807C14.656 29.7447 16.0571 28.3627 16.0571 25.9008V3.8439C16.0571 1.38203 14.6538 0 12.1785 0H12.1807Z"
			fill="var(--wpds-color-background-track-neutral-weak, #E0E0E0)"
		/>
		<Path
			d="M11.5647 1.98438H4.49023V3.98187H11.5647V1.98438Z"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
	</SVG>
);
